<template>
    <div class="table-expand-container">
        <rcTable ref="rcTable"
                 v-if="!loading"
                 :tableAttr="tableAttr">
        </rcTable>
        <div class="footer"
             style="text-align: right;padding: 5px 0;">
            <Page v-if="pageData.show"
                  size="small"
                  :total="total"
                  :current="pageData.current"
                  :pageSize="pageData.pageSize"
                  :pageSizeOpts="pageData.pageSizeOpts"
                  :placement="pageData.placement"
                  :showTotal="pageData.showTotal"
                  :showElevator="pageData.showElevator"
                  :showSizer="pageData.showSizer"
                  :transfer="pageData.transfer"
                  @on-change="onPageNumChange"
                  @on-page-size-change="onPageSizeChange" />
        </div>
    </div>
</template>
<script>
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api'
export default {
    name: 'expandRow',
    components: {
        rcTable
    },
    props: {
        ids: String,
        statusMap: Object
    },
    data () {
        return {
            loading: true,
            total: 0,
            pageData: {
                show: true,
                pageWays: 'server', // 前端分页 client, 后端分页 server
                current: 1,
                pageSize: 10,
                pageSizeOpts: [10, 20, 30, 40],
                placement: 'bottom',
                showTotal: true,
                showElevator: true,
                showSizer: true,
                transfer: true
            },
            tableAttr: {
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                // pageData: {
                //     pageWays: 'client'
                // },
                pageData: {
                    show: false
                },
                searchShow: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('账单号'),
                        key: 'billNo',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        width: 160,
                        resizable: true,
                        render: (h, params) => h('span', { attrs: { title: params.row.billNo } }, params.row.billNo || '--')
                    },
                    {
                        title: this.$t('账户ID'),
                        key: 'userAccountId',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 160,
                        render: (h, params) => {
                            const { userAccountId } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(userAccountId) } }, userAccountId || '--')
                        }
                    },
                    {
                        title: this.$t('账户名称'),
                        key: 'entityName',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        render: (h, params) => {
                            const { entityName } = params.row
                            return h('span', { class: 'tbl-operate', attrs: { title: this.$t(entityName) } }, entityName || '--')
                        }
                    },
                    {
                        title: this.$t('产品名称'),
                        key: 'productName',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        width: 150,
                        resizable: true,
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', { attrs: { title: this.$i18n.t('产品名称') } }, this.$t('产品名称')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'right', theme: 'light' }
                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', {
                                        slot: 'content',
                                        style: {
                                            // color: '#ff6a01'
                                        }
                                    }, [
                                        h('p', this.$t('HPC专属资源池产品为配置集群收费项'))
                                    ]
                                    )]
                                    )
                                ])
                        },
                        render: (h, params) => h('span', { attrs: { title: params.row.productName } }, this.$t(params.row.productName) || '--')
                    },
                    {
                        title: this.$t('账单周期'),
                        key: 'billingCycle',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 90,
                        render: (h, params) => h('span', { attrs: { title: params.row.billingCycle } }, params.row.billingCycle || '--')
                    },
                    {
                        title: this.$t('开票状态'),
                        key: 'status',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 90,
                        render: (h, params) => {
                            const { invoiceStatus } = params.row
                            const stateName = this.statusMap[invoiceStatus]
                            return h('statusview', {
                                props: {
                                    state: invoiceStatus,
                                    stateName
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('原始金额'),
                        key: 'pretaxGrossAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        width: 140,
                        render: (h, params) => {
                            const { pretaxGrossAmount } = params.row
                            return h('span', { class: params.row.pretaxGrossAmount >= 0 ? 'balance-color' : 'balance-color-green', attrs: { title: pretaxGrossAmount } }, this.$money(pretaxGrossAmount, 5) || '--')
                        }
                    },
                    {
                        title: this.$t('优惠金额'),
                        key: 'pricingDiscount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        width: 150,
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', { attrs: { title: this.$i18n.t('优惠金额') } }, this.$t('优惠金额')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'right', theme: 'light' }
                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', {
                                        slot: 'content',
                                        style: {
                                            // color: '#ff6a01'
                                        }
                                    }, [
                                        h('p', this.$t('包含折扣优惠、折扣包优惠、优惠券抵扣金额、充值现金券支付金额、抵扣现金券支付金额。'))
                                    ]
                                    )]
                                    )
                                ])
                        },
                        render: (h, params) => {
                            const { pricingDiscount, couponDiscount, couponAmount, deductCouponDiscount, bagDiscountAmount } = params.row
                            const amount = pricingDiscount + couponDiscount + couponAmount + deductCouponDiscount + bagDiscountAmount
                            return h('Poptip', {
                                class: 'balance-color',
                                props: {
                                    disabled: amount === 0,
                                    trigger: 'hover',
                                    placement: params.index === 0 ? 'right' : 'right-end',
                                    offset: 10
                                }
                            }, [
                                this.$money(amount, 5), h('i', {
                                    style: {
                                        display: 'inline-block',
                                        width: '20px',
                                        'text-align': 'left',
                                        'vertical-align': 'middle',
                                        color: '#2d8cf0',
                                        'margin-left': '5px'
                                    },
                                    class: amount && 'icon-prompt-1-o'
                                }),
                                h('div', {
                                    slot: 'content',
                                    style: {
                                        'text-align': 'left'
                                    }
                                }, [
                                    h('p', this.$t('充值现金券') + `:${this.$money(couponAmount || 0, 5)}`),
                                    h('p', this.$t('抵扣现金券') + `:${this.$money(deductCouponDiscount || 0, 5)}`),
                                    h('p', this.$t('优惠券抵扣') + `:${this.$money(couponDiscount || 0, 5)}`),
                                    h('p', this.$t('折扣包优惠') + `:${this.$money(bagDiscountAmount || 0, 5)}`),
                                    h('p', {
                                        style: {
                                            'padding-left': '12px'
                                        }
                                    }, this.$t('折扣优惠') + `:${this.$money(pricingDiscount || 0, 5)}`)
                                ])
                            ])
                        }
                    },
                    // {
                    //     title: this.$t('优惠后金额'),
                    //     key: 'pretaxAmount',
                    //     disabledSearch: true,
                    //     columnShow: true,
                    //     columnsChoosed: true,
                    //     className: 'ellipsis',
                    //     render: (h, params) => {
                    //         const { pretaxAmount } = params.row
                    //         return h('span', { class: 'balance-color', attrs: { title: pretaxAmount } }, this.$money(pretaxAmount) || '--')
                    //     }
                    // },
                    {
                        title: this.$t('现金支付金额'),
                        key: 'cashAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        width: 140,
                        render: (h, params) => {
                            const { cashAmount } = params.row
                            return h('span', { class: params.row.cashAmount >= 0 ? 'balance-color' : 'balance-color-green', attrs: { title: cashAmount } }, this.$money(cashAmount) || '--')
                        }
                    },
                    {
                        title: this.$t('信用额度支付金额'),
                        key: 'creditAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        width: 140,
                        render: (h, params) => {
                            const { creditAmount } = params.row
                            return h('span', { class: 'balance-color', attrs: { title: creditAmount } }, this.$money(creditAmount) || '--')
                        }
                    },
                    {
                        title: this.$t('充值现金券支付金额'),
                        key: 'couponAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        minWidth: 120,
                        render: (h, params) => {
                            const { couponAmount } = params.row
                            return h('span', { class: 'balance-color', attrs: { title: couponAmount } }, this.$money(couponAmount) || '--')
                        }
                    },
                    {
                        title: this.$t('抵扣现金券支付金额'),
                        key: 'voucherAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        align: 'right',
                        width: 140,
                        render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.deductCouponDiscount } }, this.$money(params.row.deductCouponDiscount))
                    },
                    {
                        title: this.$t('抹零金额'),
                        key: 'eraseZeroAmount',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        align: 'right',
                        render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.eraseZeroAmount } }, this.$money(params.row.eraseZeroAmount, 5))
                    },
                    {
                        title: this.$t('出账金额'),
                        key: 'accountName',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        align: 'right',
                        minWidth: 140,
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', { attrs: { title: this.$i18n.t('出账金额') } }, this.$t('出账金额')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'left', theme: 'light' }
                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '30px',
                                            'margin-left': '5px'
                                        }
                                    }),
                                    h('div', {
                                        slot: 'content',
                                        style: {
                                            // color: '#ff6a01'
                                        }
                                    }, [
                                        h('p', this.$t('包含充值现金券支付金额、抵扣现金券支付金额、现金支付金额和信用额度支付金额。'))
                                    ]
                                    )]
                                    )
                                ])
                        },
                        render: (h, params) => {
                            const total = this.totalPay(params.row)
                            const totalStr = this.$money(total)
                            return h('span', {
                                class: Number(total) >= 0 ? 'balance-color' : 'balance-color-green',
                                attrs: { title: totalStr }
                            }, totalStr)
                        }
                    },
                    {
                        title: this.$t('收费规则'),
                        key: 'chargingType',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        width: 100,
                        resizable: true,
                        render: (h, { row }) => {
                            const txt = this.$t({ '01': '正常计费', '02': '销售计费' }[row.chargingType || '01'])
                            return h('span', { attrs: { title: txt } }, txt)
                        }
                    }
                ]
            }
        }
    },
    created () {
        this.getTableData()
    },
    methods: {
        getTableData () {
            const data = {
                ids: this.ids,
                pagesize: this.pageData.pageSize || 10,
                pagenum: this.pageData.current - 1 || 0
            }
            this.axios.post(this.urlFormat(API.BILLS_LIST_BILL_DETAILS), data).then(res => {
                this.total = res.totalRows || 0
                this.tableAttr.source.tableData = {
                    totalRows: res.totalRows || 0,
                    dataList: res.dataList || []
                }
                this.$nextTick(() => {
                    this.$refs.rcTable.refreshTable()
                })
                this.loading = false
            })
        },
        // 页码改变
        onPageNumChange (current) {
            this.pageData.current = current
            this.getTableData()
        },
        // 每页条数改变
        onPageSizeChange (pageSize) {
            this.pageData.pageSize = pageSize
            this.getTableData()
        },
        totalPay (item) {
            const { cashAmount, creditAmount, couponAmount, deductCouponDiscount } = item
            return cashAmount + creditAmount + couponAmount + deductCouponDiscount
        }
    }
}
</script>
<style lang="less" scoped>
.table-expand-container {
    width: 100%;
    background: #f5f6f7;
    padding: 10px 0;
    /deep/ .newRcTable .rcTable-content .ivu-table .ivu-table-header thead th {
        height: 42px;
        font-size: 14px;
        font-weight: 500;
        border-bottom: none !important;
        border: 1px solid #e9e9e9 !important;
        background-color: #f0f2f3 !important;
    }
}
</style>
